module.exports = __webpack_public_path__ + "static/img/apl digital.a140961b.png";